import { gql } from "@apollo/client";

export const CREATE_POINT_ADJUSTMENT = gql`
  mutation CreatePointAdjustment($input: PointAdjustmentInput!) {
    createPointAdjustment(input: $input) {
      ok
    }
  }
`;

export const UPDATE_POINT_ADJUSTMENT = gql`
  mutation UpdatePointAdjustment($id: Int!, $input: PointAdjustmentInput!) {
    updatePointAdjustment(id: $id, input: $input) {
      ok
    }
  }
`;

export const DELETE_POINT_ADJUSTMENT = gql`
  mutation DeletePointAdjustment($id: Int!) {
    deletePointAdjustment(id: $id) {
      ok
    }
  }
`;